import { Col, Row, Typography } from 'antd'
import React from 'react'
import { GlobalFooter, GlobalHeader } from '../src/components/components'
import { getDomain } from '../src/utils'

const { Text } = Typography

export default function Maintenance() {
  return (
    <div className="cure-inner-container">
      <div className="container">
        <GlobalHeader />
        <>
          <div className="mi-pip-upload express-policy-change maintenance">
          <Row>
            <Col lg={24} md={24} sm={24} xl={24} xs={24}>
            <Text className="claim-center-text-below-title maintenance-text">
              My Account is undergoing scheduled maintenance for approximately 24 hours.
            </Text><br />
              <div className="logo-holder">
                <img alt="404-logo" src="https://assets.cure.com/img/main-site/cure-logo-maintenance.png" />
              </div>
              <br />
            <Text className="claim-center-text-below-title maintenance-text">
              Exciting changes are coming soon! We apologize for the inconvenience. In the meantime, these online services are available: <a href={"https://" + getDomain('payments')}>Make Payment</a> and <a href="https://www.cure.com/g/express-policy-changes">Request Policy Change.</a>
            </Text>
            </Col>
          </Row>
          </div>
        </>
        <GlobalFooter />
      </div>
    </div>
  )
}
